module.exports = __webpack_public_path__ + "static/media/firefox.1ec9895c.svg";